<template>
  <div class="login-wrapper">
    <div class="origin" id="origin" ref="origin" :class="{ shared: shared }">
      <img src="./share.jpg" class="origin-img" @load="loadImg" />
      <div class="head">
        <img src="./logo.png" class="avatar" />
        <div class="head-text">
          <div class="user" @click="generatorImage">{{ info.nickName }}</div>
          <div class="text">邀请你来加入</div>
        </div>
      </div>
      <div class="user-wrapper">
        <div class="avatar-list">
          <div
            class="avatar-item"
            v-for="(item, index) in avatarList"
            :key="index"
          >
            <img :src="item.url" class="avatar-item-img" />
          </div>
        </div>
        <div class="user-num">已有{{ info.distributeCount }}人加入</div>
      </div>
      <vue-qr
        class="qr"
        :text="qr.url"
        :margin="0"
        colorDark="#000"
        colorLight="#fff"
        :logoSrc="qr.icon"
        :logoScale="0.2"
      ></vue-qr>
    </div>
    <div class="share-wrapper">
      <img :src="shareImg" class="share-img" @load="shareImgLoad" />
      <div class="share-tips">长按上方图片保存并发送微信好友</div>
      <div class="share-footer">
        <div class="footer" @click="toShare">
          <div class="icon"></div>
          <div class="footer-text">分享</div>
        </div>
      </div>
      <div
        class="share-mask"
        :class="{ active: shareLink }"
        @click.stop="hideMask"
      >
        <div class="share-arrow"></div>
        <div class="share1">
          <img src="./share1.png" alt="" />
        </div>
        <div class="share2">
          <img src="./share2.png" alt="" />
        </div>
      </div>
    </div>
    <div class="mask" v-if="!isShow">分享海报生成中。。。</div>
  </div>
</template>
<script>
import html2canvas from "html2canvas"
import vueQr from "vue-qr"
import domtoimage from "dom-to-image"
import wx from "weixin-js-sdk"
import { ERROR_OK } from "../../request/http"
import { getAppId, getSdk } from "../../request/api/study"
import { getDistributor } from "../../request/api/share"
export default {
  components: {
    vueQr
  },
  data () {
    return {
      qr: {},
      shareImg: "",
      isShow: false,
      avatar: "",
      isLoad: false,
      shared: false,
      info: {},
      shareLink: false,
      avatarList: [
        {
          url: require("./1.png")
        },
        {
          url: require("./2.png")
        },
        {
          url: require("./3.png")
        },
        {
          url: require("./4.png")
        }
      ]
    }
  },
  mounted () { },
  created () {
    this.distributorId = this.$route.query.distributorId
    this.distributorType = this.$route.query.distributorType
    this.getInfo()
    if (
      navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
      "micromessenger"
    ) {
      this.getAppIdInfo()
    }
  },
  watch: {
    isLoad (newValue) {
      if (newValue) {
        let isLinux = /Linux/i.test(navigator.platform)
        if (isLinux) {
          this.shotPic()
        } else {
          this.generatorImage()
        }
      }
    }
  },
  methods: {
    toShare () {
      this.shareLink = true
    },
    hideMask () {
      this.shareLink = false
    },
    loadImg () {
      console.log(444)
      this.isLoad = true
    },
    shareImgLoad () {
      this.isShow = true
    },
    // 获取信息
    getInfo () {
      getDistributor({
        distributorId: this.distributorId,
        distributorType: this.distributorType
      }).then(res => {
        if (res.code === ERROR_OK) {
          this.info = res.data
          const BASEURL = "http://jimuaike.cn"
          this.qr = {
            url: `${BASEURL}/api/web/wechat/auth/scanCode/poster?distributeCode=${this.info.distributeCode}&distributorType=${this.distributorType}&distributorId=${this.distributorId}`,
            icon: require("./logo.png")
          }
        }
      })
    },
    // 安卓使用的分享
    shotPic () {
      setTimeout(() => {
        let node = document.getElementById("origin")
        domtoimage
          .toJpeg(node, { quality: 0.95 })
          .then(dataUrl => {
            console.log(dataUrl, "ios空白11")
            this.shareImg = dataUrl
            this.shared = true
          })
          .catch(function (error) {
            console.error("oops, something went wrong!", error)
          })
      }, 500)
    },
    // ios使用的分享
    generatorImage () {
      setTimeout(() => {
        let _this = this
        _this.photoShow = true
        // 声明一个画布元素,存储需下载图片范围
        let canvas = document.createElement("canvas")
        // 获取需下载范围元素
        let img = this.$refs["origin"]
        // 图片高度
        var w = parseInt(window.getComputedStyle(img).width)
        // 图片宽度
        var h = parseInt(window.getComputedStyle(img).height)
        // 声明画布宽高
        canvas.width = w
        canvas.height = h
        canvas.style.width = w + "px"
        canvas.style.height = h + "px"
        html2canvas(img, { canvas: canvas, scale: 4 }).then(canvas => {
          this.shareImg = canvas.toDataURL()
          this.shared = true
        })
      }, 500)
    },
    async getAppIdInfo () {
      let { code, data } = await getAppId({})
      if (code === ERROR_OK) {
        console.log(data)
        const appId = data.appId
        let timestamp = Math.floor(+new Date() / 1000)
        let nonceStr = timestamp + "1"
        let url = window.location.href.split("#")[0]
        let { code: sdkCode, data: sdkData } = await getSdk({
          timestamp,
          nonceStr,
          url,
          appId
        })
        if (sdkCode === ERROR_OK) {
          const signature = sdkData.signature
          await wx.config({
            debug: false,
            appId,
            timestamp,
            nonceStr,
            signature,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
          })
          wx.error(res => {
            console.log(res)
          })
          wx.ready(() => {
            this.updateAppMessageShareData()
            this.updateTimelineShareData()
          })
        }
      }
    },
    updateAppMessageShareData () {
      let title = "趣味思维体验课"
      let desc = `激发学习兴趣，培养思维能力，让未来学习更轻松！`
      wx.updateAppMessageShareData({
        title,
        desc,
        link: window.location.href,
        imgUrl:
          "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2010/XDinrRecWKTmpMbKC7jrmtzeakRGYi3y.png",
        success () { }
      })
    },
    updateTimelineShareData () {
      let title = "趣味思维体验课"
      let desc = `激发学习兴趣，培养思维能力，让未来学习更轻松！`
      wx.updateTimelineShareData({
        title,
        desc,
        link: window.location.href,
        imgUrl:
          "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2010/XDinrRecWKTmpMbKC7jrmtzeakRGYi3y.png",
        success () { }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.login-wrapper {
  .origin {
    position: relative;
    &.shared {
      display: none;
    }
    .origin-img {
      display: block;
      width: 100%;
      height: auto;
    }
    .head {
      position: absolute;
      left: 40px;
      top: 48px;
      display: flex;
      align-items: center;
      //   padding: 48px 0 0 40px;
      .avatar {
        width: 88px;
        height: 88px;
        border-radius: 50%;
      }
      .head-text {
        margin-left: 16px;
        text-align: left;
        .user {
          font-size: 48px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #222222;
          line-height: 45px;
        }
        .text {
          margin-top: 2px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 34px;
        }
      }
    }
    .user-wrapper {
      position: absolute;
      left: 58px;
      bottom: 46px;
      display: flex;
      align-items: center;
      .avatar-list {
        display: flex;
        align-items: center;
        .avatar-item {
          position: relative;
          width: 40px;
          height: 40px;
          .avatar-item-img {
            display: block;
            width: 40px;
            height: 40px;
          }
        }
        .avatar-item + .avatar-item {
          margin-left: -16px;
        }
      }
      .user-num {
        margin-left: 12px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 40px;
      }
    }
    .qr {
      position: absolute;
      right: 67px;
      bottom: 88px;
      width: 156px;
      height: 156px;
      border-radius: 8px;
    }
  }
  .share-wrapper {
    position: absolute;
    top: 0px;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 99;
    background: #f4f4f4;
    .share-img {
      width: 500px;
      margin: 130px auto 0;
    }
    .share-tips {
      margin: 32px auto 0;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #222222;
      line-height: 37px;
    }
    .share-footer {
      position: absolute;
      width: 100%;
      height: 120px;
      left: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      .footer {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 658px;
        height: 90px;
        background: #0293de;
        border-radius: 45px;
        .icon {
          width: 40px;
          height: 40px;
          background: url("./link.png") no-repeat;
          background-size: cover;
        }
        .footer-text {
          margin-left: 10px;
          font-size: 34px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
    .share-mask {
      display: none;
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1000;
      background: rgba(0, 0, 0, 0.7);
      &.active {
        display: block;
      }
      .share-arrow {
        position: absolute;
        top: 131px;
        right: 84px;
        width: 132px;
        height: 205px;
        background: url("./share-arrow.png") no-repeat;
        background-size: cover;
      }
      .share1 {
        position: absolute;
        top: 336px;
        left: 50%;
        transform: translateX(-50%);
        img {
          display: block;
          width: 270px;
        }
      }
      .share2 {
        position: absolute;
        top: 392px;
        left: 50%;
        transform: translateX(-50%);
        img {
          display: block;
          width: 388px;
        }
      }
    }
  }
  .mask {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    color: #222222;
    font-size: 36px;
    z-index: 999;
  }
}
</style>
